import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCompanyStatsApi } from '../Utils/Axios';

// Async thunk to fetch company stats for dashboard
export const fetchCompanyStats = createAsyncThunk(
    'companyStats/fetchCompanyStats',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getCompanyStatsApi();
            return response.data.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to fetch company stats'
            );
        }
    }
);

// Slice
const companyStatsSlice = createSlice({
    name: 'companyStats',
    initialState: {
        data: { total: 0, active: 0, pending: 0 },
        loading: false,
        error: null,
    },
    reducers: {
        clearCompanyStats: (state) => {
            state.data = { total: 0, active: 0, pending: 0 };
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCompanyStats.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCompanyStats.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCompanyStats.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearCompanyStats } = companyStatsSlice.actions;
export default companyStatsSlice.reducer;
